import { Icon, Stack, Text, TooltipHost } from '@fluentui/react';
import { useState } from 'react';
import {
  TrainingFolders_trainingFolders_nodes__childFolders_edges_node__childFolders_nodes_trainingFiles_nodes,
  TrainingFolders_trainingFolders_nodes__childFolders_edges_node_trainingFiles_nodes,
} from '../__generated__/TrainingFolders';
import { HelpContentViewModal } from './HelpContentViewModal';
import { useStyles } from './index.styles';
import { useCommonStyles } from 'common/styles';

export const SearchRightPanel: React.FC<{
  trainingFilesNodes:
    | TrainingFolders_trainingFolders_nodes__childFolders_edges_node__childFolders_nodes_trainingFiles_nodes[]
    | TrainingFolders_trainingFolders_nodes__childFolders_edges_node_trainingFiles_nodes[];
  selectedNodeName: string | null;
  isDataAvailable: boolean;
  trainingFoldersDataLoading: boolean;
}> = ({
  trainingFilesNodes,
  selectedNodeName,
  isDataAvailable,
  trainingFoldersDataLoading,
}) => {
  const styles = useStyles();
  const commonStyles = useCommonStyles();
  const [showModal, setShowModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState<
    | TrainingFolders_trainingFolders_nodes__childFolders_edges_node__childFolders_nodes_trainingFiles_nodes
    | undefined
  >(undefined);

  const iconType = (iconType: string) => {
    switch (iconType) {
      case 'PDF':
        return 'PDF';
      case 'VIDEO':
        return 'MSNVideos';
      default:
        return 'FileCode';
    }
  };

  return (
    <>
      <Stack tokens={{ childrenGap: 20, padding: '30px' }}>
        <Stack
          horizontal
          style={{ paddingBottom: 20 }}
          tokens={{ childrenGap: 5 }}
        >
          {trainingFoldersDataLoading && (
            <Text variant="xLarge">Searching for help documents -</Text>
          )}
          {selectedNodeName && (
            <Text className={commonStyles.colorThemePrimary} variant="xLarge">
              {selectedNodeName}
            </Text>
          )}
        </Stack>

        {!trainingFilesNodes?.length ? (
          isDataAvailable ? (
            <Text variant="smallPlus">Please choose a folder.</Text>
          ) : (
            <Text variant="smallPlus">No document is available.</Text>
          )
        ) : (
          <Stack className={styles.container}>
            {trainingFilesNodes?.map((file) => (
              <Stack
                horizontal
                key={file.id}
                verticalAlign="center"
                tokens={{ childrenGap: 12 }}
                className={styles.fileCard}
                onClick={() => {
                  setSelectedFile(file);
                  setShowModal(true);
                }}
              >
                <Stack horizontal verticalAlign="center" grow>
                  <TooltipHost content={file.hint ?? undefined}>
                    <Stack
                      horizontal
                      tokens={{ childrenGap: 8 }}
                      verticalAlign="center"
                    >
                      <Icon
                        iconName={iconType(file.iconType ?? '')}
                        styles={{ root: { fontSize: 20 } }}
                      />
                      <Text styles={{ root: { fontWeight: 500 } }}>
                        {file.name}
                      </Text>
                    </Stack>
                  </TooltipHost>
                </Stack>
              </Stack>
            ))}
          </Stack>
        )}
      </Stack>
      {showModal && selectedFile && (
        <HelpContentViewModal
          selectedFile={selectedFile}
          setShowModal={setShowModal}
        />
      )}
    </>
  );
};
